import { TypeaheadAdapter } from '@app/adapters/types'

export default class SyncAutoComplete {
  constructor({
    element,
    data,
    typeahead,
  }: {
    element: HTMLInputElement
    data: string[]
    typeahead: TypeaheadAdapter
  }) {
    typeahead(element, {
      source: (
        query?: string,
        process?: (callback: unknown) => string | string[] | object[]
      ) => {
        const matches: string[] = []
        const substrRegex = query ? new RegExp(query, 'i') : false

        data.forEach((str) => {
          if (substrRegex && substrRegex.test(str)) {
            matches.push(str)
          }
        })

        if (process && typeof process === 'function') {
          process(matches)
        }
      },
    })
  }
}
